export const EVENTS = {
	ON_OFFERS_SEARCH: 'on-offers-search'
};

export const CATEGORIES = {
	SALES: 'sales',
	TECHNICAL: 'technical'
};
